<template>
  <div class="wp-history-comment-heading">
    <strong class="wp-history-comment-heading__title">
      <span v-if="showIndex">{{ index }}.&nbsp;</span>{{ title }}
    </strong>
    <div class="last-update wp-history-comment-heading__byline">
      <div class="last-update__text">
        {{ byline }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WpHistoryCommentHeading',
  props: {
    index: {
      type: [Number, String],
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    byline: {
      type: String,
      required: true,
    },
  },
  computed: {
    showIndex () {
      return this.index != null && this.index !== ''
    },
  },
}
</script>

<style lang="scss" scoped>
.wp-history-comment-heading {
  padding-top: 3px;
}

.wp-history-comment-heading__title {
  font-weight: bold;
  font-size: 14px;
  margin: 0 0 4px 0;
  line-height: 1.35;
}

.wp-history-comment-heading__byline {
  margin-top: 10px;
  margin-bottom: 15px;
}

.wp-history-comment-heading__byline .last-update__text {
  font-style: italic;
  font-size: 13px;
}
</style>
